/**
 * RMFF Reports Filters Widget - Enhanced Multi-Select Version
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var ReportsFiltersWidget = /** @class */ (function () {
    function ReportsFiltersWidget(widgetId) {
        this.keywordInput = null;
        this.topicSelect = null;
        this.yearSelect = null;
        this.activeFiltersRow = null;
        this.filterPills = null;
        this.clearAllBtn = null;
        this.resetLink = null;
        this.clearAllLink = null;
        this.selectedTopics = [];
        this.selectedYears = [];
        this.currentKeyword = '';
        this.debounceTimer = null;
        this.isInitializingFromURL = false;
        this.widgetId = widgetId;
        this.init();
    }
    ReportsFiltersWidget.prototype.init = function () {
        var _this = this;
        this.bindElements();
        this.bindEvents();
        this.loadFilterData();
        // Initialize from URL parameters after a short delay to ensure data is loaded
        setTimeout(function () { return _this.initializeFromURL(); }, 100);
        this.bindHistoryEvents();
        this.handleResponsiveClearAllPosition();
        window.addEventListener('resize', function () { return _this.handleResponsiveClearAllPosition(); });
    };
    ReportsFiltersWidget.prototype.bindElements = function () {
        var widget = document.querySelector("[data-widget-id=\"".concat(this.widgetId, "\"]"));
        if (!widget)
            return;
        this.keywordInput = widget.querySelector('.rmff-keyword-input');
        this.topicSelect = widget.querySelector('[data-type="topic"]');
        this.yearSelect = widget.querySelector('[data-type="year"]');
        this.activeFiltersRow = widget.querySelector('.rmff-active-filters');
        this.filterPills = widget.querySelector('.rmff-filter-pills');
        this.clearAllBtn = widget.querySelector('.rmff-clear-all-filters-btn');
        this.resetLink = widget.querySelector('.rmff-reset-link');
        this.clearAllLink = widget.querySelector('.rmff-clear-all-filters-link');
    };
    ReportsFiltersWidget.prototype.bindEvents = function () {
        var _this = this;
        // Keyword search
        if (this.keywordInput) {
            this.keywordInput.addEventListener('input', function () {
                _this.debounce(function () {
                    var _a;
                    _this.currentKeyword = ((_a = _this.keywordInput) === null || _a === void 0 ? void 0 : _a.value.trim()) || '';
                    _this.updateActiveFiltersVisibility();
                    _this.updateFilterPills();
                    _this.triggerFilterEvent();
                }, 1000);
            });
        }
        // Topic select
        if (this.topicSelect) {
            this.bindCustomSelectEvents(this.topicSelect, 'topics');
        }
        // Year select
        if (this.yearSelect) {
            this.bindCustomSelectEvents(this.yearSelect, 'years');
        }
        // Clear all button (legacy support)
        if (this.clearAllBtn) {
            this.clearAllBtn.addEventListener('click', function () {
                _this.clearAllFilters();
            });
        }
        // Reset link
        if (this.resetLink) {
            this.resetLink.addEventListener('click', function (e) {
                e.preventDefault();
                _this.clearAllFilters();
            });
        }
        // Clear all link
        if (this.clearAllLink) {
            this.clearAllLink.addEventListener('click', function (e) {
                e.preventDefault();
                _this.clearAllFilters();
            });
        }
    };
    ReportsFiltersWidget.prototype.bindCustomSelectEvents = function (selectElement, type) {
        var _this = this;
        var trigger = selectElement.querySelector('.rmff-select-trigger');
        var dropdown = selectElement.querySelector('.rmff-select-dropdown');
        var clearAllBtn = selectElement.querySelector('.rmff-clear-all-btn');
        // Toggle dropdown
        if (trigger) {
            trigger.addEventListener('click', function (e) {
                e.stopPropagation();
                _this.toggleDropdown(selectElement);
            });
        }
        // Handle option clicks
        var optionsContainer = selectElement.querySelector('.rmff-select-options');
        if (optionsContainer) {
            optionsContainer.addEventListener('change', function (e) {
                var target = e.target;
                if (target.type === 'checkbox') {
                    _this.handleOptionChange(target, type);
                }
            });
        }
        // Clear all button
        if (clearAllBtn) {
            clearAllBtn.addEventListener('click', function (e) {
                e.preventDefault(); // keep href="#" for styling but prevent scroll
                e.stopPropagation();
                _this.clearSelectType(type);
            });
        }
        // Close dropdown when clicking outside
        document.addEventListener('click', function (e) {
            if (!selectElement.contains(e.target)) {
                _this.closeDropdown(selectElement);
            }
        });
    };
    ReportsFiltersWidget.prototype.toggleDropdown = function (selectElement) {
        var trigger = selectElement.querySelector('.rmff-select-trigger');
        var dropdown = selectElement.querySelector('.rmff-select-dropdown');
        var isOpen = dropdown.classList.contains('show');
        // Close all other dropdowns
        document.querySelectorAll('.rmff-select-dropdown.show').forEach(function (dd) {
            dd.classList.remove('show');
        });
        document.querySelectorAll('.rmff-select-trigger.active').forEach(function (tr) {
            tr.classList.remove('active');
        });
        if (!isOpen) {
            dropdown.classList.add('show');
            trigger.classList.add('active');
        }
    };
    ReportsFiltersWidget.prototype.closeDropdown = function (selectElement) {
        var trigger = selectElement.querySelector('.rmff-select-trigger');
        var dropdown = selectElement.querySelector('.rmff-select-dropdown');
        dropdown.classList.remove('show');
        trigger.classList.remove('active');
    };
    ReportsFiltersWidget.prototype.handleOptionChange = function (checkbox, type) {
        var value = checkbox.value;
        var isChecked = checkbox.checked;
        if (type === 'topics') {
            if (isChecked) {
                this.selectedTopics.push(value);
            }
            else {
                this.selectedTopics = this.selectedTopics.filter(function (t) { return t !== value; });
            }
        }
        else {
            if (isChecked) {
                this.selectedYears.push(value);
            }
            else {
                this.selectedYears = this.selectedYears.filter(function (y) { return y !== value; });
            }
        }
        this.updateSelectDisplay(type);
        this.updateClearAllButton(type);
        this.updateActiveFiltersVisibility();
        this.updateFilterPills();
        this.triggerFilterEvent();
    };
    ReportsFiltersWidget.prototype.updateSelectDisplay = function (type) {
        var selectElement = type === 'topics' ? this.topicSelect : this.yearSelect;
        if (!selectElement)
            return;
        var placeholder = selectElement.querySelector('.rmff-select-placeholder');
        var selectedValues = type === 'topics' ? this.selectedTopics : this.selectedYears;
        if (selectedValues.length === 0) {
            placeholder.textContent = type === 'topics' ? 'Select Topic(s)' : 'Select Year(s)';
        }
        else if (selectedValues.length === 1) {
            // Capitalize the first letter for topics
            var displayValue = type === 'topics'
                ? selectedValues[0].charAt(0).toUpperCase() + selectedValues[0].slice(1)
                : selectedValues[0];
            placeholder.textContent = displayValue;
        }
        else {
            placeholder.textContent = "".concat(selectedValues.length, " ").concat(type, " selected");
        }
    };
    ReportsFiltersWidget.prototype.updateClearAllButton = function (type) {
        var selectElement = type === 'topics' ? this.topicSelect : this.yearSelect;
        if (!selectElement)
            return;
        var clearAllContainer = selectElement.querySelector('.rmff-select-clear-all');
        var selectedValues = type === 'topics' ? this.selectedTopics : this.selectedYears;
        if (selectedValues.length > 0) {
            clearAllContainer.style.display = 'block';
        }
        else {
            clearAllContainer.style.display = 'none';
        }
    };
    ReportsFiltersWidget.prototype.updateActiveFiltersVisibility = function () {
        if (!this.activeFiltersRow)
            return;
        var hasActiveFilters = this.currentKeyword.length > 0 ||
            this.selectedTopics.length > 0 ||
            this.selectedYears.length > 0;
        // Find the top-level Elementor element container (the one with the background color)
        // We need to traverse up the DOM tree to find the container-level elementor-element
        var widget = document.querySelector("[data-widget-id=\"".concat(this.widgetId, "\"]"));
        var topLevelElement = null;
        if (widget) {
            // Start from the widget and traverse up to find the container-level elementor-element
            var currentElement = widget.parentElement;
            while (currentElement) {
                if (currentElement.classList.contains('elementor-element') &&
                    currentElement.classList.contains('e-con') &&
                    currentElement.classList.contains('e-parent')) {
                    topLevelElement = currentElement;
                    break;
                }
                currentElement = currentElement.parentElement;
            }
        }
        if (hasActiveFilters) {
            this.activeFiltersRow.style.display = 'flex';
            if (this.resetLink) {
                this.resetLink.style.display = 'block';
            }
            if (topLevelElement) {
                topLevelElement.classList.add('has-active-filters');
            }
        }
        else {
            this.activeFiltersRow.style.display = 'none';
            if (this.resetLink) {
                this.resetLink.style.display = 'none';
            }
            if (topLevelElement) {
                topLevelElement.classList.remove('has-active-filters');
            }
        }
    };
    ReportsFiltersWidget.prototype.updateFilterPills = function () {
        var _this = this;
        var _a;
        if (!this.filterPills)
            return;
        // Remove only the pill elements, not the clear all link
        var pills = this.filterPills.querySelectorAll('.rmff-filter-pill');
        pills.forEach(function (pill) { return pill.remove(); });
        // Add keyword pill
        if (this.currentKeyword) {
            var pill = this.createPill(this.currentKeyword, 'keyword');
            (_a = this.filterPills) === null || _a === void 0 ? void 0 : _a.appendChild(pill);
        }
        // Add topic pills
        this.selectedTopics.forEach(function (topic) {
            var _a;
            var pill = _this.createPill(topic, 'topic');
            (_a = _this.filterPills) === null || _a === void 0 ? void 0 : _a.appendChild(pill);
        });
        // Add year pills
        this.selectedYears.forEach(function (year) {
            var _a;
            var pill = _this.createPill(year, 'year');
            (_a = _this.filterPills) === null || _a === void 0 ? void 0 : _a.appendChild(pill);
        });
        // Ensure clear all link is positioned correctly after updating pills
        this.handleResponsiveClearAllPosition();
    };
    ReportsFiltersWidget.prototype.createPill = function (value, type) {
        var _this = this;
        var pill = document.createElement('div');
        pill.className = 'rmff-filter-pill';
        pill.setAttribute('data-type', type);
        pill.setAttribute('data-value', value);
        // Capitalize the first letter for topics
        var displayValue = type === 'topic' ? value.charAt(0).toUpperCase() + value.slice(1) : value;
        pill.innerHTML = "\n            <span>".concat(displayValue, "</span>\n            <button type=\"button\" class=\"rmff-pill-remove\" aria-label=\"Remove ").concat(type, " filter\">\u00D7</button>\n        ");
        // Add click handler to remove pill
        pill.addEventListener('click', function () {
            _this.removePill(value, type);
        });
        return pill;
    };
    ReportsFiltersWidget.prototype.removePill = function (value, type) {
        var _a, _b;
        if (type === 'keyword') {
            this.currentKeyword = '';
            if (this.keywordInput) {
                this.keywordInput.value = '';
            }
        }
        else if (type === 'topic') {
            this.selectedTopics = this.selectedTopics.filter(function (t) { return t !== value; });
            // Uncheck the corresponding checkbox
            var checkbox = (_a = this.topicSelect) === null || _a === void 0 ? void 0 : _a.querySelector("input[value=\"".concat(value, "\"]"));
            if (checkbox)
                checkbox.checked = false;
            this.updateSelectDisplay('topics');
            this.updateClearAllButton('topics');
        }
        else {
            this.selectedYears = this.selectedYears.filter(function (y) { return y !== value; });
            // Uncheck the corresponding checkbox
            var checkbox = (_b = this.yearSelect) === null || _b === void 0 ? void 0 : _b.querySelector("input[value=\"".concat(value, "\"]"));
            if (checkbox)
                checkbox.checked = false;
            this.updateSelectDisplay('years');
            this.updateClearAllButton('years');
        }
        this.updateActiveFiltersVisibility();
        this.updateFilterPills();
        this.triggerFilterEvent();
    };
    ReportsFiltersWidget.prototype.clearSelectType = function (type) {
        var selectElement = type === 'topics' ? this.topicSelect : this.yearSelect;
        if (!selectElement)
            return;
        // Uncheck all checkboxes
        var checkboxes = selectElement.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach(function (checkbox) {
            checkbox.checked = false;
        });
        // Clear arrays
        if (type === 'topics') {
            this.selectedTopics = [];
        }
        else {
            this.selectedYears = [];
        }
        this.updateSelectDisplay(type);
        this.updateClearAllButton(type);
        this.updateActiveFiltersVisibility();
        this.updateFilterPills();
        this.triggerFilterEvent();
    };
    ReportsFiltersWidget.prototype.clearAllFilters = function () {
        // Clear keyword
        if (this.keywordInput) {
            this.keywordInput.value = '';
            this.currentKeyword = '';
        }
        // Clear topics
        this.clearSelectType('topics');
        // Clear years
        this.clearSelectType('years');
    };
    ReportsFiltersWidget.prototype.loadFilterData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, error_1;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, fetch(((_a = window.rmff_ajax) === null || _a === void 0 ? void 0 : _a.ajax_url) || '/wp-admin/admin-ajax.php', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded',
                                },
                                body: new URLSearchParams({
                                    action: 'get_reports_filter_data',
                                    nonce: ((_b = window.rmff_ajax) === null || _b === void 0 ? void 0 : _b.nonce) || ''
                                })
                            })];
                    case 1:
                        response = _c.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _c.sent();
                        if (data.success) {
                            this.populateTopics(data.data.topics || []);
                            this.populateYears(data.data.years || []);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _c.sent();
                        console.error('Error loading filter data:', error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ReportsFiltersWidget.prototype.populateTopics = function (topics) {
        var _this = this;
        if (!this.topicSelect)
            return;
        var optionsContainer = this.topicSelect.querySelector('.rmff-select-options');
        if (!optionsContainer)
            return;
        optionsContainer.innerHTML = '';
        topics.forEach(function (topic) {
            var option = document.createElement('div');
            option.className = 'rmff-select-option';
            option.innerHTML = "\n                <input type=\"checkbox\" id=\"topic-".concat(topic.value, "-").concat(_this.widgetId, "\" value=\"").concat(topic.value, "\">\n                <label for=\"topic-").concat(topic.value, "-").concat(_this.widgetId, "\">\n                    <div class=\"rmff-custom-checkbox\">\n                        <div class=\"rmff-checkmark\">\n                            <svg width=\"15\" height=\"13\" viewBox=\"0 0 15 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                                <path d=\"M1.10132 7.80872L4.96465 11.1457L13.3626 1.42289\" stroke=\"#B83D41\" stroke-width=\"2\"/>\n                            </svg>\n                        </div>\n                    </div>\n                    ").concat(topic.label, "\n                </label>\n            ");
            optionsContainer.appendChild(option);
        });
    };
    ReportsFiltersWidget.prototype.populateYears = function (years) {
        var _this = this;
        if (!this.yearSelect)
            return;
        var optionsContainer = this.yearSelect.querySelector('.rmff-select-options');
        if (!optionsContainer)
            return;
        optionsContainer.innerHTML = '';
        years.forEach(function (year) {
            var option = document.createElement('div');
            option.className = 'rmff-select-option';
            option.innerHTML = "\n                <input type=\"checkbox\" id=\"year-".concat(year, "-").concat(_this.widgetId, "\" value=\"").concat(year, "\">\n                <label for=\"year-").concat(year, "-").concat(_this.widgetId, "\">\n                    <div class=\"rmff-custom-checkbox\">\n                        <div class=\"rmff-checkmark\">\n                            <svg width=\"15\" height=\"13\" viewBox=\"0 0 15 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                                <path d=\"M1.10132 7.80872L4.96465 11.1457L13.3626 1.42289\" stroke=\"#B83D41\" stroke-width=\"2\"/>\n                            </svg>\n                        </div>\n                    </div>\n                    ").concat(year, "\n                </label>\n            ");
            optionsContainer.appendChild(option);
        });
    };
    ReportsFiltersWidget.prototype.getCurrentFilters = function () {
        return {
            keyword: this.currentKeyword,
            topics: __spreadArray([], this.selectedTopics, true),
            years: __spreadArray([], this.selectedYears, true)
        };
    };
    ReportsFiltersWidget.prototype.triggerFilterEvent = function () {
        var filters = this.getCurrentFilters();
        var event = new CustomEvent('rmff-reports-filtered', {
            detail: {
                widgetId: this.widgetId,
                filters: filters
            }
        });
        document.dispatchEvent(event);
        // Update URL to reflect current filters
        this.updateURL();
    };
    ReportsFiltersWidget.prototype.debounce = function (func, wait) {
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }
        this.debounceTimer = window.setTimeout(function () {
            func();
        }, wait);
    };
    /**
     * Ensure filters are reapplied when navigating via browser history (back/forward)
     */
    ReportsFiltersWidget.prototype.bindHistoryEvents = function () {
        var _this = this;
        window.addEventListener('popstate', function () {
            _this.initializeFromURL();
        });
        window.addEventListener('pageshow', function (event) {
            var e = event;
            // If coming from bfcache or normal navigation, re-initialize
            if (!e || e.persisted === true || e.persisted === false) {
                _this.initializeFromURL();
            }
        });
    };
    /**
     * Get URL parameters from the current page URL
     */
    ReportsFiltersWidget.prototype.getURLParameters = function () {
        var urlParams = new URLSearchParams(window.location.search);
        return {
            topics: urlParams.get('topics') || undefined,
            years: urlParams.get('years') || undefined,
            keywords: urlParams.get('keywords') || undefined
        };
    };
    /**
     * Initialize filters from URL parameters
     */
    ReportsFiltersWidget.prototype.initializeFromURL = function () {
        var _this = this;
        var params = this.getURLParameters();
        // Set flag to prevent URL update during initialization
        this.isInitializingFromURL = true;
        // Parse topics parameter (comma-separated values)
        if (params.topics) {
            var topics = params.topics.split(',').map(function (t) { return t.trim(); }).filter(function (t) { return t; });
            topics.forEach(function (topic) {
                var _a;
                if (!_this.selectedTopics.includes(topic)) {
                    _this.selectedTopics.push(topic);
                    // Check the corresponding checkbox
                    var checkbox = (_a = _this.topicSelect) === null || _a === void 0 ? void 0 : _a.querySelector("input[value=\"".concat(topic, "\"]"));
                    if (checkbox) {
                        checkbox.checked = true;
                    }
                }
            });
            if (topics.length > 0) {
                this.updateSelectDisplay('topics');
                this.updateClearAllButton('topics');
            }
        }
        // Parse years parameter (comma-separated values)
        if (params.years) {
            var years = params.years.split(',').map(function (y) { return y.trim(); }).filter(function (y) { return y; });
            years.forEach(function (year) {
                var _a;
                if (!_this.selectedYears.includes(year)) {
                    _this.selectedYears.push(year);
                    // Check the corresponding checkbox
                    var checkbox = (_a = _this.yearSelect) === null || _a === void 0 ? void 0 : _a.querySelector("input[value=\"".concat(year, "\"]"));
                    if (checkbox) {
                        checkbox.checked = true;
                    }
                }
            });
            if (years.length > 0) {
                this.updateSelectDisplay('years');
                this.updateClearAllButton('years');
            }
        }
        // Parse keywords parameter
        if (params.keywords) {
            this.currentKeyword = params.keywords;
            if (this.keywordInput) {
                this.keywordInput.value = this.currentKeyword;
            }
        }
        // Update UI if any filters were set from URL
        if (params.topics || params.years || params.keywords) {
            this.updateActiveFiltersVisibility();
            this.updateFilterPills();
            this.triggerFilterEvent();
        }
        // Reset flag after initialization
        this.isInitializingFromURL = false;
    };
    /**
     * Update the URL with current filter selections
     */
    ReportsFiltersWidget.prototype.updateURL = function () {
        // Don't update URL if we're currently initializing from URL parameters
        if (this.isInitializingFromURL) {
            return;
        }
        var url = new URL(window.location.href);
        // Update or remove topics parameter
        if (this.selectedTopics.length > 0) {
            url.searchParams.set('topics', this.selectedTopics.join(','));
        }
        else {
            url.searchParams.delete('topics');
        }
        // Update or remove years parameter
        if (this.selectedYears.length > 0) {
            url.searchParams.set('years', this.selectedYears.join(','));
        }
        else {
            url.searchParams.delete('years');
        }
        // Update or remove keywords parameter
        if (this.currentKeyword) {
            url.searchParams.set('keywords', this.currentKeyword);
        }
        else {
            url.searchParams.delete('keywords');
        }
        // Clear pagination-related parameters to reset results
        // This ensures that when filters change, we start from page 1 with default pagination
        url.searchParams.delete('paged');
        url.searchParams.delete('page');
        url.searchParams.delete('posts_per_page');
        // Update URL without page reload
        window.history.pushState({}, '', url.toString());
    };
    /**
     * Handle responsive positioning of clear all link
     * On mobile: move inside filter pills container
     * On desktop: move back to original position
     */
    ReportsFiltersWidget.prototype.handleResponsiveClearAllPosition = function () {
        if (!this.clearAllLink || !this.filterPills || !this.activeFiltersRow)
            return;
        var isMobile = window.innerWidth <= 768;
        var clearAllParent = this.clearAllLink.parentElement;
        if (isMobile) {
            // Move clear all link inside pills container as first child (if not already there)
            if (clearAllParent !== this.filterPills) {
                this.filterPills.insertBefore(this.clearAllLink, this.filterPills.firstChild);
            }
        }
        else {
            // Move clear all link back to active filters row as first child (if not already there)
            if (clearAllParent !== this.activeFiltersRow) {
                this.activeFiltersRow.insertBefore(this.clearAllLink, this.activeFiltersRow.firstChild);
            }
        }
    };
    return ReportsFiltersWidget;
}());
export function initReportsFiltersWidgets() {
    // Initialize all reports filters widgets on the page
    var widgets = document.querySelectorAll('.rmff-reports-filters-widget');
    widgets.forEach(function (widget) {
        var widgetId = widget.getAttribute('data-widget-id');
        if (widgetId) {
            new ReportsFiltersWidget(widgetId);
        }
    });
}
